import { TransferRequestUpdatePage } from "@/features/transfer-request/pages/TransferRequestUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-request/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferRequestUpdatePage,
});
